"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var LiveStatus;
(function (LiveStatus) {
    LiveStatus[LiveStatus["LIVE"] = 0] = "LIVE";
    LiveStatus[LiveStatus["LIVE_SOON"] = 1] = "LIVE_SOON";
    LiveStatus[LiveStatus["NOT_LIVE"] = 2] = "NOT_LIVE";
    LiveStatus[LiveStatus["LIVE_IN_X_DAYS"] = 3] = "LIVE_IN_X_DAYS";
})(LiveStatus = exports.LiveStatus || (exports.LiveStatus = {}));
//# sourceMappingURL=LiveStatus.js.map